import { motion } from "framer-motion";
import { BENEFITS } from "../data";
import { Wallet, CalendarClock, Gauge, MapPinned, BadgeCheck, Zap } from "lucide-react";

const icons = { Wallet, CalendarClock, Gauge, MapPinned, BadgeCheck, Zap };

export const Benefits = () => {
  return (
    <section id="vorteile" className="relative mx-auto max-w-7xl scroll-mt-24 px-5 py-24 md:px-10 md:py-32">
      <div className="aurora left-[20%] top-[10%] h-72 w-72 bg-[#3B82F6] opacity-20" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative mb-16 text-center"
      >
        <span className="text-sm font-bold uppercase tracking-[0.25em] text-[#60A5FA]">Warum TSU-Partners</span>
        <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-white md:text-5xl">
          Deine Vorteile als <span className="gradient-text">Fahrer</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-gray-300 md:text-lg">
          Ein seriöser, flexibler Verdienst mit klaren Abläufen und persönlicher Betreuung – ideal als Nebenjob, Hauptjob oder für Studierende.
        </p>
      </motion.div>

      <div className="relative grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {BENEFITS.map((b, i) => {
          const Icon = icons[b.icon];
          return (
            <motion.div
              key={i}
              data-testid={`benefit-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0B111E] p-8 transition-all duration-300 hover:-translate-y-2 hover:border-[#60A5FA]/40 hover:shadow-[0_20px_50px_-20px_rgba(139,92,246,0.5)]"
            >
              <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-to-br from-[#3B82F6] to-[#60A5FA] text-white shadow-lg shadow-[#3B82F6]/30 transition-transform duration-300 group-hover:scale-110">
                <Icon className="h-7 w-7" />
              </div>
              <h3 className="font-heading text-xl font-bold text-white">{b.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-gray-400">{b.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
